// Skeleton — applies .skeleton shimmer class while the container has
// aria-busy="true". Removed when aria-busy flips to false.
// Pair with phx-loading classes or manual aria-busy toggling.
export default {
  mounted() {
    this.observer = new MutationObserver(() => this.apply())
    this.observer.observe(this.el, { attributes: true, attributeFilter: ["aria-busy"] })
    this.apply()
  },
  destroyed() {
    this.observer && this.observer.disconnect()
  },
  apply() {
    const busy = this.el.getAttribute("aria-busy") === "true"
    this.el.classList.toggle("skeleton", busy)
  },
}
